import VueRouter, { RouteConfig } from 'vue-router'

const Report = () => import('../views/exercise-prescription/Report.vue')

export const reportWeeklyRoute: RouteConfig = {
  path: '/exercise-prescription-report-weekly',
  name: 'exercise_prescription_report_weekly',
  component: Report,
  props: (route) => ({ ...route.query, ...route.params, type: 'weeklyExercisePrescription' }),
  meta: {
    title: '运动处方周报',
  },
}

export default [reportWeeklyRoute]

export function navigateToExercisePrescriptionReportWeekly(router: VueRouter, date: string) {
  router.push({ name: reportWeeklyRoute.name, query: { date } })
}
